"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Column_1 = require("./Column");
var SelectColumn_1 = require("./SelectColumn");
var utils = require("./utils");
var classNames = require("classnames");
var react_router_dom_1 = require("react-router-dom");
var ListRow = React.memo(function (props) {
    var index = props.index, _a = props.data, items = _a.items, currentBriefcase = _a.currentBriefcase, currentBid = _a.currentBid, selectedLanguage = _a.selectedLanguage, selected = _a.selected, toggleSelect = _a.toggleSelect, style = props.style;
    var row = items[index];
    var link;
    if (currentBriefcase) {
        link = utils.letterLink(selectedLanguage, currentBriefcase, currentBid, row);
    }
    else {
        link = utils.portalLink(selectedLanguage, currentBid, row);
    }
    return (React.createElement("div", { className: classNames('row'), style: style },
        currentBriefcase ? (React.createElement(SelectColumn_1.default, { row: row, selected: selected, toggleSelect: toggleSelect })) : (React.createElement("div", { className: "row__column narrow" })),
        React.createElement(react_router_dom_1.Link, { to: link },
            React.createElement(Column_1.default, { column: "id", row: row })),
        React.createElement(react_router_dom_1.Link, { to: link },
            React.createElement(Column_1.default, { column: "name", row: row })),
        React.createElement(Column_1.default, { column: "description", row: row }),
        currentBriefcase && React.createElement(Column_1.default, { column: "status", row: row }),
        React.createElement(Column_1.default, { column: "publishedAt", row: row }),
        currentBriefcase && React.createElement(Column_1.default, { column: "updatedAt", row: row }),
        React.createElement("div", { className: "row__column narrow" })));
});
exports.default = ListRow;
